module.exports = __webpack_public_path__ + "img/B2.ee055355.png";